import { initialize } from './methods';

initialize();




// WEBPACK FOOTER //
// ./src/index.js